import React from 'react';

const experienceContent = [
  {
    year: 'November 2024 - April 2025',
    position: 'Frontend Developer',
    compnayName: 'Deutsche Post and DHL',
    details: ` Collaborated in multi-developer teams with focus on maintaining code
 consistency and development speed.
 Applied best practices, including modular design, reusable components,
 and comprehensive documentation, to streamline contributions. `,
  },
  {
    year: 'May 2023 - June 2024',
    position: 'Frontend Developer',
    compnayName: 'Falkonet',
    details: ` Entered the company with no prior knowledge of React and Next.js,
 but quickly upskilled through self-learning and project involvement, mainly
 focusing on frontend development.
 Solved a major performance issue by implementing the useReducer hook to
 optimize state management, reducing unnecessary re-renders and improving
 app speed by 30%.`,
  },
  {
    year: 'January 2023 - March 2023',
    position: 'Internship',
    compnayName: 'StarLabs',
    details: `Contributed to web application development using JavaScript and  SASS, improving functionality and user experience.
              Collaborated effectively within a team environment, gaining experience in version control with Git and GitHub.`,
  },
  {
    year: 'July 2021 - December 2021',
    position: 'Freelance Web Developer',
    compnayName: 'Self employed',
    details: `Built small projects and experimental projects to develop my skills`,
  },
  {
    year: 'June 2020 - May 2021',
    position: 'IT Assistant | Part Time',
    compnayName: 'AAB College',
    details: ``,
  },
];

const Experience = () => {
  return (
    <ul>
      {experienceContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.position}
            <span className="place open-sans-font">{val.compnayName}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Experience;
